/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1094
 */

var r = require(/* 231 */"../1282/231")
var o = require(/* 714 */"../1648/714")
var i = require(/* 246 */"../1782/246/index")("match")
module.exports = function (e) {
  var t
  return r(e) && (undefined !== (t = e[i]) ? !!t : "RegExp" == o(e))
}
